import { JsonObject, JsonProperty } from "typescript-json-serializer";
// *Geo.js Properties*
@JsonObject()
export class MetadataConfiguration {

    /**
     * URL template to get metadata for layers
     */
    @JsonProperty()
    declare urlTemplate: string;

    /**
     * METAUID for each layer
     * Object dictionary with layer name as key and metauid as value
     * To overwrite layer metauid, use metauid as key and new metauid as value or an object with layer ID as key
     * and new metauid as value
     * {
     *    "MFNKSTAO_DS": "MFNKSTAO_COL",
     *    "MFNKSTAO_DS": {"0": "MFNKSTAO_COL"},
     *    "Bauinventar (BILU)": "BILUKDVX_COL"
     *  }
     */
    @JsonProperty()
    declare metauid: any;

    constructor() {}
}
